/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import { call, put, takeLatest } from 'redux-saga/effects';

import { axiosMicro } from '~/services';
import * as Actions from './actions';

function* getListDeliveryRouteRequestReceipt({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get(payload?.params ? `/tp-delivery-routes/request-receipts?${payload.params}` : '/tp-delivery-routes/request-receipts?limit=0'));
    yield put(Actions.getDeliveryRouteRequestReceiptSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.getDeliveryRouteRequestReceiptFailure(messages));
    }
  }
}

function* updateStatusDeliveryRouteRequestReceipt({ payload }) {
  try {
    const response = yield call(() => axiosMicro.patch(`/tp-delivery-routes/${payload.id}/request-receipt`, payload.body));
    yield put(Actions.updateStatusDeliveryRouteRequestReceiptSuccess(response.data));
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.updateStatusDeliveryRouteRequestReceiptFailure(messages));
    }
  }
}

// eslint-disable-next-line func-names
export default function* () {
  yield takeLatest(Actions.getDeliveryRouteRequestReceiptRequest, getListDeliveryRouteRequestReceipt);
  yield takeLatest(Actions.updateStatusDeliveryRouteRequestReceiptRequest, updateStatusDeliveryRouteRequestReceipt);
}
